import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center" }
const _hoisted_2 = { class: "max-w-[1113px] mx-auto" }
const _hoisted_3 = { class: "flex justify-center w-full" }
const _hoisted_4 = {
  key: 0,
  id: "box-comment",
  class: "flex justify-center w-full"
}
const _hoisted_5 = { class: "flex justify-center w-full" }
const _hoisted_6 = { class: "text-xl font-medium text-h-neutral-900" }
const _hoisted_7 = { class: "mx-4 mt-4 mb-6 font-semibold text-h-neutral-900" }
const _hoisted_8 = ["for"]
const _hoisted_9 = { class: "p-0 text-h-neutral-900" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_BreadcrumbForum = _resolveComponent("BreadcrumbForum")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_TopicCardDetailed = _resolveComponent("TopicCardDetailed")!
  const _component_ListComments = _resolveComponent("ListComments")!
  const _component_CommentInput = _resolveComponent("CommentInput")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createVNode(_component_Loader, {
      loader: _ctx.isTopicLoading,
      label: _ctx.$t('labels.generic', { pt: 'Carregando...', en: 'Loading...' }),
      loaderType: "progress"
    }, null, 8, ["loader", "label"]),
    (_ctx.isTeacherOrAdmin() && !_ctx.isTopicLoading)
      ? (_openBlock(), _createBlock(_component_BreadcrumbForum, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("section", {
      class: _normalizeClass(["!max-w-[1344px] custom-container-forum mt-6", [{'hidden' : _ctx.isTopicLoading}]])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "mb-6 h-8 py-0.5 flex gap-3 items-center btn-simple px-0",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.backToForumView()))
        }, [
          _createVNode(_component_v_icon, {
            name: "co-arrow-left",
            width: "24",
            height: "24"
          }),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("labels.generic", {
            pt: "Voltar para fórum",
            en: "Go back to forum",
          })), 1)
        ])
      ]),
      _createVNode(_component_TopicCardDetailed, {
        topic: _ctx.topic,
        onDenounceTopic: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleDenounceDialog(true)))
      }, null, 8, ["topic"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ListComments, {
          comments: _ctx.comments,
          topic: _ctx.topic,
          totalComments: _ctx.totalComments,
          query: _ctx.query,
          numberOfCommentsPerPage: _ctx.numberOfCommentsPerPage,
          onDeleteComment: _ctx.refreshComment,
          onPaginate: _ctx.changePage,
          onReplyComment: _ctx.replyComment
        }, null, 8, ["comments", "topic", "totalComments", "query", "numberOfCommentsPerPage", "onDeleteComment", "onPaginate", "onReplyComment"])
      ]),
      (_ctx.topic?.status === _ctx.status.ACTIVE)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_CommentInput, {
              topicId: _ctx.topicId,
              replyOfComment: _ctx.replyOfComment,
              onIsSubmitting: _ctx.isSubmittingComment,
              onRemoveReplyComment: _ctx.removeReplyComment,
              onCommentCreated: _ctx.commentCreated
            }, null, 8, ["topicId", "replyOfComment", "onIsSubmitting", "onRemoveReplyComment", "onCommentCreated"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_Dialog, {
        group: "denounce",
        visible: _ctx.isDenounceDialogVisible,
        "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.isDenounceDialogVisible) = $event)),
        style: { maxWidth: '540px' },
        class: "w-11/12 custom-dialogForum text-h-neutral-900",
        modal: ""
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.$t("forum.topic.denounce.title")), 1)
          ])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_Button, {
              class: "btn-outline !h-8",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleDenounceDialog(false)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("forum.topic.denounce.buttons.cancel")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Button, {
              class: "btn-primary !h-8",
              onClick: _ctx.denounceTopic,
              disabled: !_ctx.selectedDenounce
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("forum.topic.denounce.buttons.sendReport")), 1)
              ]),
              _: 1
            }, 8, ["onClick", "disabled"])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("forum.topic.denounce.labels.description")), 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsDenounce, (denounce) => {
              return (_openBlock(), _createElementBlock("div", {
                key: denounce.key,
                class: "flex mb-4 ml-4 align-items-center"
              }, [
                _createVNode(_component_RadioButton, {
                  modelValue: _ctx.selectedDenounce,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedDenounce) = $event)),
                  inputId: denounce.key,
                  name: "dynamic",
                  value: _ctx.$t('labels.generic', {pt: denounce.labelPT, en: denounce.labelEN})
                }, null, 8, ["modelValue", "inputId", "value"]),
                _createElementVNode("label", {
                  for: denounce.key,
                  class: "ml-2 font-semibold"
                }, [
                  _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("labels.generic", {pt: denounce.labelPT, en: denounce.labelEN})), 1)
                ], 8, _hoisted_8)
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ], 2)
  ]))
}